const defaultState = {
  data: [],
  loading: false,
  error: false,
};

const siteCanvasses = function (state = defaultState, action) {
  let data, target;

  switch (action.type) {
    // TODO: this needs to go on campaign selector and campaign selector screen
    case 'CLEAR_SITE_CANVASS_CACHE':
      return { ...state, data: [] };

    case 'SET_CAMPAIGN_SITE_CANVASSES':
      return { ...state, data: action.data };

    case 'UPDATE_SITE_CANVASS':
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data[target] = action.data;
      }
      return { ...state, data };

    case 'REMOVE_SITE_CANVASS':
      data = [...state.data];
      target = data.findIndex((d) => d.id === action.data.id);
      if (target > -1) {
        data.splice(target, 1);
      }
      return { ...state, data };

    case 'INSERT_SITE_CANVASS':
      return { ...state, data: [...state.data, action.data] };

    case 'SET_CAMPAIGN_SITE_CANVASSES_LOADING':
      return {
        ...state,
        loading: action.data,
      };

    case 'SET_CAMPAIGN_SITE_CANVASSES_ERROR':
      return {
        ...state,
        error: action.data,
      };

    default:
      return state;
  }
};

export default siteCanvasses;
